import type { ReactNode } from 'react';
import React from 'react';
import noop from 'lodash/noop';
import IconButton from '../../Button/iconButton';
import Icon from '../../Icon';
import Typography from '../../Typography';
import { useTheme } from '../../../theme';
import { HeaderWrapper, HeaderTitleWrapper, HeaderTitleRow, HeaderCloseButton } from './view';

interface Props {
    title: ReactNode;
    subtitle?: string;
    showBackButton?: boolean;
    onBack?: () => void;
    showCloseButton?: boolean;
    onClose?: () => void;
    titleTestId?: string;
    backButtonTestId?: string;
    closeButtonTestId?: string;
    className?: string;
}

export const ModalHeader = (props: Props) => {
    const {
        title,
        subtitle,
        onClose = noop,
        onBack = noop,
        showBackButton = false,
        showCloseButton = true,
        titleTestId,
        backButtonTestId,
        closeButtonTestId,
        className,
    } = props;

    const theme = useTheme();

    return (
        <HeaderWrapper className={className}>
            {showBackButton && (
                <IconButton
                    onClick={onBack}
                    size="small"
                    data-cy={backButtonTestId}
                >
                    <Icon
                        icon="icBack"
                        colorVariant="third"
                    />
                </IconButton>
            )}
            <HeaderTitleWrapper>
                <HeaderTitleRow $withCloseButton={showCloseButton}>
                    <Typography
                        block
                        variant="title9"
                        data-cy={titleTestId}
                    >
                        {title}
                    </Typography>
                </HeaderTitleRow>
                {subtitle && (
                    <Typography
                        variant="body3"
                        color={theme.root.colors.basicColors['50%']}
                    >
                        {subtitle}
                    </Typography>
                )}
            </HeaderTitleWrapper>
            {showCloseButton && (
                <HeaderCloseButton
                    onClick={onClose}
                    size="small"
                    data-cy={closeButtonTestId}
                >
                    <Icon
                        icon="icClose"
                        colorVariant="third"
                    />
                </HeaderCloseButton>
            )}
        </HeaderWrapper>
    );
};

ModalHeader.displayName = 'ModalHeader';
